<template>
  <div v-loading="$store.state.loading">
    <vuetable ref="vuetable" :fields="tablefields" :api-mode="false" :data="tabledata" no-data-template
      @vuetable:cell-clicked="cellclicked"
      >
      <template slot="tableHeader" slot-scope="props">
        <th v-for="x in props.fields" :key="x.name" v-show="x.visible != false">
          <el-button v-show="x.name != 'delete' && x.name != 'remove'" type="text" :disabled="x.name != key"
            @click="batchedit()">{{ x.title }}</el-button>
          <el-button v-show="x.name === 'delete'" type="text" :disabled="tabledata.length === 0"
            @click="$message.error('双击从数据库彻底删除')" @dblclick.native="deletemany()">{{ x.title }}</el-button>
          <el-button v-show="x.name === 'remove'" type="text" :disabled="tabledata.length === 0"
            @click.native="removemany()">{{ x.title }}</el-button>
        </th>
      </template>



      <span slot="delete" slot-scope="props">
        <el-button type="danger" icon="el-icon-delete" circle @click="$message.error('双击从数据库彻底删除')"
          @dblclick.native="deleteitem(props.rowIndex)"></el-button>
      </span>

      <span slot="remove" slot-scope="props">
        <el-button type="warning" @click="removeitem(props.rowIndex)">X</el-button>
      </span>
    </vuetable>



    <div style="position:fixed" v-bind:style="{ top: pos.y, left: pos.x, display: pos.display }">

      <form-create ref="fc" v-model="fApi" :rule="rule" :option="option"></form-create>

    </div>



    <div v-if="tabledata.length > 0">
      <el-button @click="modifydone">提交更改</el-button>
      <el-button
        v-if="$store.state.collection.pdf && ($store.state.roles.includes('dbadmin') || $store.state.collection.publicedit)"
        @click="downloadpdf">下载pdf</el-button>
    </div>
    <div style="position:fixed;right:20px;bottom:100px">
      <el-button type="danger" circle @click="addnewitem(null)">新建CREATE</el-button>
    </div>

    <div style="margin-top:100px" v-if="tabledata.length === 0">
      <p style="font-size:1em;font-weight:bold">点击有下角添加条目Add new items by clicking right-bottom button</p>
      <el-button v-if="$store.state.roles.includes('superadmin') && $store.state.collection.value.includes('tempexcel')"
        @click="$emit('switchcomponent', 'dbset')" type="warning">重置数据库</el-button>
      <el-button v-if="$store.state.roles.includes('dbadmin')"
        @click="$emit('switchcomponent', 'excelupdate')">从excel导入</el-button>
      <el-button v-if="$store.state.roles.includes('dbadmin')" type="primary" @click="shownewitems">查看提交的新条目</el-button>
    </div>

  </div>
</template>

<script>



import Vuetable from "vuetable-2";
import moment from "moment";

import Schema from 'async-validator'
import rulesprocess from "zxg-ruleprocess"

import { fieldsprocess } from "zxg-table-fieldsprocess";
// import selectopinions from "./frontedit_select.vue"

import formCreate, { maker } from "@form-create/element-ui";
// import rulesprocess from "@/components/utility/formrulesprocess";


function generateuuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
export default {
  components: {
    formCreate: formCreate.$form(),
    Vuetable,
    // selectopinions
  },

  mounted() {

    this.$el.addEventListener('paste', this.pastenewitem)

    // this.shownewitems();
    let fields = JSON.parse(JSON.stringify(this.tablefields))
    // console.log(this.tablefields)
    let rules = fields.map(obj => {

      if (obj.type == "numberrange") {
        return obj = { "type": "InputNumber", "title": obj.title, "field": obj.name, "value": "0" }
      }
      else if (obj.type == "daterange") {
        return obj = { "type": "DatePicker", "title": obj.title, "field": obj.name, "value": "'1970-01-01'" }
      }
      else {
        return obj = { "type": "Input", "title": obj.title, "field": obj.name, "value": "", props: { "type": "textarea", "autosize": true } }
      }



    })

    this.allrule = rules

    // console.log(this.fApi)

    this.$axios
      .post(url + "filter", {
        collection: "header_theform",
        fdata: { "model": "^edit_" + this.$store.state.collection.value + "$" },
        page: 1,
        log: false//不记录
      })
      .then((res) => {
        // let remoterule=rulesprocess(res.data.doc)
        this.allrule = res.data.doc.concat(this.allrule)
      })
  },

  data() {
    return {

      targetfieldobj: {},
      pos: { x: 0, y: 0, display: "none" },
      target: {},
      rowindex: 0,
      key: "",
      type: "",


      fApi: {},
      option: {
        row: { align: "center" },
        submitBtn: { show: false, innerText: "Done", icon: "" },
        onSubmit: function (formData) {
          // self.calculate()
        },
      },
      allrule: [
        {
          type: "input",
          title: "备注",
          field: "remark",
          value: "",
        }
      ],
      rule: [

      ],


    };
  },
  computed: {
    tablefields() {
      return fieldsprocess(this.$store.state.currentheader, "edit",this.$store);
    },
    tabledata() {
      return this.$store.state.edits;
    },
  },

  methods: {

    downloadpdf() {
      this.$axios.downloadpdf(
        this.$store.state.user,
        this.$store.state.collection.value,
        this.$store.state.edits
      );

    },
    shownewitems() {
      if (this.$store.state.roles.includes("dbadmin")) {
        let data = {};
        data.collection = this.$store.state.clct;
        this.$axios.post(url + "getnewitems", data).then(res => {
          if (res.data.length === 0) {
            this.$message("无提交的新条目");
          } else {
            res.data.forEach(obj => {
              this.$store.commit("setedits", obj);
            });
          }
        });
      }
    },
    pastenewitem(event) {
      // console.log("ddddd")
      let keynames = [];
      let editablefields = [];

      this.tablefields.forEach(obj => {
        if (obj.visible != false && obj.editable != false) {
          keynames.push(obj.name);
          editablefields.push(obj);
        }
      });

      let arr = [];
      let str = event.clipboardData.getData("Text");
      //如果粘贴的字符中包含了"\t"且field的type不为json，那么对数据处理为对象值
      if (str.includes("\t") && this.type != "json") {
        event.preventDefault();
      } else {
        return;
      }
      let line = str.split("\r");
      //line.pop()
      line.forEach(li => {
        let tempar = li.split("\t", keynames.length);
        this.addnewitem(tempar);
      });
    },

    addnewitem(newitemar) {
      let keynames = [];
      let editablefields = [];
      let makeobj = {};

      //默认初始值
      this.tablefields.forEach(obj => {
        switch (obj.type) {
          case "daterange":
            makeobj[obj.name] = new Date();
            break;
          case "numberrange":
            makeobj[obj.name] = 0;
            break;
          case "json":
            makeobj[obj.name] = "[]";
            break;
          case "boolean":
            makeobj[obj.name] = "false";
            break;
          case "addon":
            break;
          default:
            makeobj[obj.name] = "";
        }
        //改为服务器端
        // makeobj.name = this.$store.state.user;
        makeobj.jsonid = generateuuid(); //生成uuid用于在json中查找

        if (obj.visible != false && obj.editable != false) {
          keynames.push(obj.name);
          editablefields.push(obj);
        }
      });



      for (let i = 0; i < editablefields.length; i++) {
        let type = editablefields[i].type;
        if (newitemar && newitemar[i] != undefined) {
          switch (type) {
            case "daterange":
              makeobj[keynames[i]] = new Date(newitemar[i]);
              break;
            case "numberrange":
              makeobj[keynames[i]] = Math.round(new Number(newitemar[i]) * 1000) / 1000;
              break;
            case "json":
              makeobj[keynames[i]] = newitemar[i];
              break;
            case "boolean":
              makeobj[keynames[i]] = newitemar[i];
              break;
            default:
              makeobj[keynames[i]] = newitemar[i];
          }
        }

      }
      //console.log(this.tablefields)

      this.$store.commit("setedits", makeobj);
    },


    //用于检查edits，如果field中设置了select，那么用options来检查，值是否在options中
    editscheck() {
      let errmsgs=[]

      let rulewithvalidate = this.allrule.filter(ruleobj => {
        return ruleobj.validate && ruleobj.validate.length > 0
      })

      //如果superadmin，不受限制
      if (!this.$store.state.roles.includes("dbadmin")){
      if (rulewithvalidate.length > 0) {
        //形成descriptor，格式如 {cat: [],prj:[]}
        let descriptor={}
        //store在validator会eval用到
        let store=this.$store
        rulewithvalidate.forEach(ruleobj=>{
          //json中不能直接设置validator函数，所以在此处理，的validator是string,在此转换
          ruleobj.validate.forEach(validdetail=>{
            if(validdetail.validator_eval){

              //将json中的function转换为function，并传递store进去
              let x=new Function('store','return ' + validdetail.validator_eval);
              validdetail.validator=x(store)
    
            }

          })

          descriptor[ruleobj.field]=ruleobj.validate
        })


        const validator = new Schema(descriptor);

        this.$store.state.edits.forEach((dataobj,i)=>{
          
          validator.validate(dataobj, (errors, fields) => {
          if (errors) {
            console.log(errors);
            let errmsg=""
            errors.forEach(err=>{
              errmsg=errmsg+err.message+";"
            })

            errmsgs.push({index:i,errmsg:errmsg})

         
          } else {
            console.log("Validation succeeded");
          }
        });

        })

      }

}
      return errmsgs

    },
    // valcheck(options, theval) {

    //   if (options.includes(theval)) {
    //     return theval
    //   }
    //   else {
    //     return "Invalid"
    //   }
    // },

    // 对新建数据进行计算
    newitemcaculation() {
      let ifcal = this.tablefields.findIndex(fieldobj => { return fieldobj.name == "newitemcal" })

      if (ifcal > 0) {
        this.$store.state.edits.forEach(itemobj => {
          //只检查新创建的
          if (itemobj.jsonid) {
            eval(this.tablefields[ifcal].theeval)
          }

        })
      }


    },

    modifydone() {

      let errmsgs = this.editscheck()
      if (errmsgs.length>0) {
        this.$message(JSON.stringify(errmsgs))
        // this.$message("Some Datas Invalid")
        return
      }

      let data = {};

      this.newitemcaculation()

      data.collection = this.$store.state.collection.value;
      data.data = this.$store.state.edits;


      this.$axios.post(url + "modify", data).then(res => {
        this.$message("已更改完成");
        this.$store.commit("resetitems", "edits");
      });
    },


    cellclicked(obj) {
      // console.log(obj)
      // this.showform=false
      this.target = JSON.parse(
        JSON.stringify(this.$store.state.edits[obj.index])
      );
      this.targetfieldobj = obj.field
      this.key = obj.field.name;
      this.type = obj.field.type;
      //如果如果为object即type为json，那么对其进行stringfy，便于展示及编辑
      if (this.type === "json" && typeof this.target[this.key] != "string") {
        //         JSON.stringify(jsObj, null, "\t");
        // JSON.stringify(jsObj, null, 4);
        this.target[this.key] = JSON.stringify(this.target[this.key], null, 4);
      }
      this.rowindex = obj.index;
      this.$set(this.pos, "x", obj.event.clientX + "px");
      this.$set(this.pos, "y", obj.event.clientY + "px");
      this.$set(this.pos, "display", "block");


      let index = this.allrule.findIndex(obj => {
        return obj.field == this.key
      })

      let rawrule = JSON.parse(JSON.stringify(this.allrule[index]))
      let currentrule = rulesprocess([rawrule], this.tabledata[obj.index],{store:this.$store})[0]
      currentrule.title = ""
      currentrule.value = this.target[this.key]
      currentrule.on = {
        change: () => {
          console.log("val set")
          this.setvalue('edits', obj.index, this.key, this.fApi.getValue(this.key))
        },
      }


      this.rule = [currentrule]

    },

    setvalue(target, index, key, value) {
      // console.log(target)
      this.target[key] = value
      let obj = { target: target, index: index, key: key, value: value };
      this.editvalue = value;
      this.$store.commit("setvalue", obj);
    },

    batchedit() {
      let obj = {};
      for (let i = 0; i < this.tabledata.length; i++) {
        obj = {
          target: "edits",
          index: i,
          key: this.key,
          value: this.target[this.key]
        };
        this.$store.commit("setvalue", obj);
      }
    },

    deletemany() {
      let jsonids = this.$store.state.edits.map(obj => {
        return obj.jsonid;
      });

      let data = {
        collection: this.$store.state.collection.value,
        ids: this.$store.state.editsid,
        jsonids: jsonids
      };

      this.$axios.post(url + "deletemany", data).then(res => {
        this.$message("已从数据库删除");
        this.$store.commit("resetitems", "edits");
      });
    },
    deleteitem(index) {
      let data = {
        collection: this.$store.state.collection.value,
        jsonid: this.$store.state.edits[index].jsonid,
        id: this.$store.state.editsid[index],
        //传递path信息给backend，如果有path，那么把path文件删除
        path: this.$store.state.edits[index].path
      };

      this.$axios.post(url + "deleteitem", data).then(res => {
        this.$message("已从数据库删除");
        this.removeitem(index);
      });
    },

    removeitem(index) {
      this.$store.commit("removeitem", { where: "edits", itemindex: index });
    },
    removemany() {
      this.$store.commit("resetitems", "edits");
    },





  }
};
</script>

<style scoped>
.highlight-row {
  background-color: yellow;
}
</style>


// WEBPACK FOOTER //
// src/components/edit/frontedit.vue